import React from 'react';

const LevelCard = ({ activity, rating }) => {

    return (
        <div className='grid grid-cols-2 gap-2'>
            <div className='flex flex-col gap-2 justify-center items-center bg-green_5 rounded-xl p-4'>
                <h2 className='text-caption1_700 text-gray_160'>Activity Score</h2>
                <div className='flex gap-4 items-center'>
                    <img src='/images/mobile/icon/level/지수.svg' alt='Activity Score Icon' />
                    <h3 className='text-body2_700 text-green_100'>{activity || '-'}</h3>
                </div>
            </div>
            <div className='flex flex-col gap-2 justify-center items-center bg-green_5 rounded-xl p-4'>
                <h2 className='text-caption1_700 text-gray_160'>Level</h2>
                <div className='flex gap-4 items-center'>
                    {rating && <img src={rating.includes('Sprout') || rating.includes('새싹') ? '/images/mobile/icon/level/새싹.svg' : rating.includes('Branch') || rating.includes('가지') ? '/images/mobile/icon/level/가지.svg'
                        : rating.includes('Fruit') || rating.includes('열매') ? '/images/mobile/icon/level/열매.svg' : rating.includes('Tree') || rating.includes('나무') ? '/images/mobile/level/나무.svg' : '/images/mobile/icon/level/숲.svg'} alt='Level Icon' />}
                    <h3 className='text-body2_700 text-green_100'>{rating || '-'}</h3>
                </div>
            </div>
        </div>
    );
};

export default LevelCard;